import request from '@/utils/request'

// 获取事件源列表
export const getAlarmLevelLists = (data) => {
    return request({
        url: '/alarm/level/setting',
        params: data
    })
}

// 时间登记-详情
export const getAlarmLevelSettingDetail = (id) => {
    return request({
        url: `/alarm/level/setting/extend/${id}`
    })
}

// d等级-修改
export const putLevel = (data) => {
    return request({
        url: '/alarm/level/manage',
        method: 'PUT',
        data
    })
}

// 摄像头点位-添加
export const addCameraPoint = (data) => {
    return request({
        url: '/camera/manage',
        method: 'POST',
        data
    })
}

// 告警等级-删除
export const delAlarmLevel = (id) => {
    return request({
        url: `/alarm/level/delete/${id}`,
        method: 'DELETE'
    })
}

// 前台显示-不显示  文字闪烁-不闪烁
export const batchAlarm = (data) => {
    return request({
        url: '/alarm/level/manage',
        method: 'PATCH',
        data
    })
}

/**
 * 摄像头选项-能力级&摄像头类型
 */
export const getCapabilityCameraType = () => {
    return request({
        url: '/alarm/level/manage'
    })
}

// 勾选、移除短信接收人员
export const checkRemoveMsgMan = (id, data) => {
    return request({
        url: `/alarm/level/setting/extend/${id}`,
        method: 'POST',
        data
    })
}
